import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import ButtonBase from '@material-ui/core/ButtonBase';
import Badge from '@material-ui/core/Badge';
import ColourPickerModalWrapper from './ColourPickerModal.js';
import { observer, inject } from 'mobx-react';
import InstructionsDialog from './components/InstructionsDialog.js';
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/Info';

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        margin: 32,
    },
    grid: {
        flexGrow: 1,
    },
    paperTile: {
        backgroundColor: '#f0f0f0',
        height: 112,
        width: 80,
    },
    letterTile: {
        fontSize: 80,
        textAlign: 'center',
        lineHeight: 1.3,
        textShadow: '0px 0px 2px rgba(0, 0, 0, 0.17)'
    },
    badge: {
        backgroundColor: '#9e9e9e'
    },
    floatingHelpButton: {
        position: 'fixed',
        top: 0,
        right: 0
    }

});


@inject( 'wcpStore' )
@observer
class LetterColours extends Component {

    state = {
        colourPickerOpen: false,
        colourPickerLetter: 'A',
        instructionsOpen: true
    };

    handleModalColorClose = (colour, success) => {
        if (success) {
            this.props.setLetterColour(this.state.colourPickerLetter, colour);
        }

        this.setState({
            colourPickerOpen: false,

        });
    };

    handleLetterClick = (letter) => {
        this.setState({
            colourPickerOpen: true,
            colourPickerLetter: letter
        });
    };

    handleModalInstructionsClose = () => {
        this.setState({
            instructionsOpen: false,
        });
    };

    helpButtonClicked = () => {
        this.setState({
            instructionsOpen: true,
        });
    }


    render() {

        const { classes } = this.props;
        const { colourPickerOpen, colourPickerLetter,instructionsOpen } = this.state;
        const { letters, letterColours } = this.props.wcpStore;

        const selectedLetterColour = letterColours[colourPickerLetter] || '';

        return (
            <div className={classes.root}>
                {!instructionsOpen && <div className={classes.floatingHelpButton}>
                    <IconButton color="secondary"
                                onClick={this.helpButtonClicked}
                        >
                        <InfoIcon />
                    </IconButton>
                </div>}
                <InstructionsDialog open={instructionsOpen} step={1} handleClose={this.handleModalInstructionsClose} />
                <Grid container cellheight={100} className={classes.grid} spacing={16}>
                    {letters.map((l,index)=> {

                        const colorSet = letterColours[l] !== undefined && letterColours[l] !== '';
                        const badgeContent = colorSet ? '' : '?';
                        const colour = colorSet ? letterColours[l] : '#f0f0f0';
                        //debugger;
                        return(

                            <Grid key={index} item>
                                <Badge classes={{badge:classes.badge}} color='primary'  badgeContent={badgeContent} >
                                    <Paper className={classes.paperTile} style={{color: colour  }}>
                                        <ButtonBase

                                            key={index}
                                            className={classes.letterTile}
                                            focusVisibleClassName={classes.letterTile}
                                            onClick={() => this.handleLetterClick(l)}>
                                            {l}
                                        </ButtonBase>
                                    </Paper>
                                </Badge>
                            </Grid>


                    )})}
                </Grid>

                <ColourPickerModalWrapper
                    colour={selectedLetterColour}
                    open={colourPickerOpen}
                    modalClose={this.handleModalColorClose}
                />
            </div>
        );
    }
}

export default withStyles(styles)(LetterColours);